/*
 * @Description: 
 * @Author: 长老
 * @Date: 2019-05-31 09:46:41
 * @lastTime: 2020-03-04 15:36:38
 * @LastAuthor: WE1ZHANTA0
 */
import Vue from 'vue'
import Router from 'vue-router'
import { eachRouter } from 'src/assets/js/Util'

Vue.use(Router)

const Meta = title => ({ title: title })

const routes = [
  {
    path: '/share-coupon',
    component: () => import(/* webpackChunkName: "AmendmentApplication" */ './views/ShareCoupon/Index.vue'),
    meta: Meta('云集大红包')
  }, {
    path: '/share-cloud',
    component: () => import(/* webpackChunkName: "AmendmentApplication" */ './views/ShareCloud/ShareCloud.vue'),
    meta: Meta('云集钻石团长发云币啦，快来领取')
  }, {
    path: '/share-cloud-applet',
    component: () => import(/* webpackChunkName: "AmendmentApplication" */ './views/ShareCloud/Applet.vue'),
    meta: Meta('云集钻石团长发云币啦，快来领取')
  }, {
    path: '/share-clouds',
    component: () => import(/* webpackChunkName: "AmendmentApplication" */ './views/ShareCloud/ShareCloud.vue'),
    meta: Meta('云集钻石团长发云币啦，快来领取')
  }, {
    path: '/category-nav',
    component: () => import(/* webpackChunkName: "AmendmentApplication" */ './views/CategoryNav/CategoryNav.vue'),
    meta: Meta('分类导购')
  }, {
    path: '/commodity-list',
    component: () => import(/* webpackChunkName: "AmendmentApplication" */ './views/CommodityList/CommodityList.vue'),
    meta: Meta('商品列表')
  }, {
    path: '/brand-list',
    component: () => import(/* webpackChunkName: "AmendmentApplication" */ './views/BrandList/BrandList.vue'),
    meta: Meta('品牌列表')
  }, {
    path: '/redPacketRewards',
    component: () => import(/* webpackChunkName: "AmendmentApplication" */ './views/MyRewards/redPacket.vue'),
    meta: Meta('我的奖励')
  }
]

// 路由正则处理，用于微信防封
eachRouter(routes)

export default new Router({
  mode: 'history',
  base: '/yjcommodity',
  routes: routes
})
